var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.0-Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Home---ativos",
    transform: "translate(-943.000000, -1424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions-/-Toggle-/-phone--filled-/-20",
    transform: "translate(0.000000, 1332.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(943.055947, 92.062499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8190532,17.8750013 L15.7021782,17.8750013 C2.19280317,17.0981263 0.274678166,5.6993763 0.00655316641,2.2206263 C-0.0370806629,1.67435452 0.13848054,1.13317611 0.494484029,0.716548837 C0.850487518,0.299921565 1.35766112,0.0421023585 1.90405317,6.47553858e-07 L5.69217817,6.47553858e-07 C6.25565846,-0.000544185972 6.76244062,0.342759863 6.97092817,0.866251297 L8.01592817,3.4375013 C8.22160281,3.94841192 8.10256957,4.5327569 7.71342817,4.9225013 L6.24905317,6.4006263 C6.71760308,9.06327835 8.79889501,11.1500618 11.4603032,11.6256263 L12.9521782,10.1475013 C13.347817,9.7626192 13.9352617,9.65162736 14.4440532,9.8656263 L17.0359282,10.9037513 C17.5513224,11.1187346 17.885503,11.6240808 17.8815878,12.1825013 L17.8815878,15.8125013 C17.8815878,16.9515886 16.9581405,17.8750013 15.8190532,17.8750013 Z M2.06905317,1.3750013 C1.6893574,1.3750013 1.38155317,1.68280553 1.38155317,2.0625013 L1.38155317,2.1175013 C1.69780317,6.1875013 3.72592817,15.8125013 15.7778032,16.5000013 C15.9602203,16.5112759 16.1396191,16.4494521 16.2763618,16.3281897 C16.4131044,16.2069273 16.4959353,16.0362078 16.5065532,15.8537513 L16.5065532,12.1825013 L13.9146782,11.1443763 L11.9415532,13.1037513 L11.6115532,13.0625013 C5.63030317,12.3131263 4.81905317,6.3318763 4.81905317,6.2700013 L4.77780317,5.9400013 L6.73030317,3.9668763 L5.69905317,1.3750013 L2.06905317,1.3750013 Z",
    id: "Fill",
    fill: "#000000"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.c69709c8466af9b22cfdf5e937261c1e.svg";
export { ForwardRef as ReactComponent };